import type { AuthProviderValue, AuthRules, HostedAuthRules } from './types';

export function hostedAuthRules(auth: AuthProviderValue, requiredRoles: Array<string> = []): HostedAuthRules {
  const { user } = auth;

  function isNotLoggedIn() {
    return !user.loggedIn;
  }

  function isNotAuthorized() {
    if (!user.hasAccess) {
      return true;
    }

    if (requiredRoles.length < 1) {
      return false;
    }

    return !requiredRoles.every((role) => user.roles.includes(role));
  }

  return {
    isNotLoggedIn,
    isNotAuthorized,
  };
}

export function authRules(auth: AuthProviderValue, requireStrongAuth: boolean): AuthRules {
  const { user, sessionExpirationDate } = auth;

  function isSessionExpired() {
    return sessionExpirationDate < Date.now();
  }
  function isNotLoggedIn() {
    return !user.loggedIn;
  }
  function isBlocked() {
    return !isImpersonating() && user.isUserBlocked;
  }
  function isImpersonating() {
    return Boolean(user.impersonatorUserToken && user.impersonatorEmail);
  }
  function isMissingStrongAuth() {
    if (isImpersonating() || !requireStrongAuth) {
      return false;
    }

    return !user.hasStrongAuthentication;
  }
  function isMissingRecentStrongAuth() {
    if (isImpersonating() || !requireStrongAuth) {
      return false;
    }

    return !user.hasStrongAuthentication || isSessionExpired();
  }
  return {
    isNotLoggedIn,
    isBlocked,
    isImpersonating,
    isMissingStrongAuth,
    isMissingRecentStrongAuth,
    isSessionExpired,
  };
}
